import { Autocomplete, Checkbox, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function GlobalAutoCompleteMultiSelectNoFormik({
  data = [],
  label = 'Multi Select',
  keys = { id: 'id', value: 'value' },
  sx = { width: '100%' },
  onChange,
  limitTags,
  setKeyName = 'id',
  loading = false,
}) {
  return (
    <Autocomplete
      loading={loading}
      multiple
      disableCloseOnSelect
      limitTags={limitTags || undefined}
      options={data}
      isOptionEqualToValue={(option, value) => option[keys.id] === value[keys.id]}
      getOptionLabel={(option) => option[keys.value] || ''}
      sx={sx}
      onChange={(_, selected) => {
        const values = selected?.map((s) => s[keys[setKeyName]]);

        onChange(values);
      }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;

        return (
          <li key={key} {...optionProps}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
            {option[keys?.value]}
          </li>
        );
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}
